import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import {
  _ResultWrap, _Result, _ResultItem, _ResultSubtitle, _ResultBg,
} from './styles'

// @todo Add image after we get thumbnail image from algolia
const SearchResultItem = ({ item, isHighlighted, className = '', onClickItem, userIsAuthentificated }) => {
  const isArchivedListing = item.filter_type === 'mls_number' && item.status !== 'Active'
  const title = !userIsAuthentificated && isArchivedListing ?
    'Log in to view address' : item.title

  return (
    <_ResultWrap className={className} onClick={onClickItem}>
      <_Result>
        <_ResultItem>{title}</_ResultItem>
        <_ResultSubtitle>{item.subtitle}</_ResultSubtitle>
      </_Result>
      <_ResultBg isHighlighted={isHighlighted} />
    </_ResultWrap>
  )
}


SearchResultItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    url: PropTypes.string,
    status: PropTypes.string,
    filter_type: PropTypes.string,
  }).isRequired,
  isHighlighted: PropTypes.bool,
  className: PropTypes.string,
  onClickItem: PropTypes.func,
  userIsAuthentificated: PropTypes.bool,
}

const mapStateToProps = state => ({
  userIsAuthentificated: state.userData.userIsAuthentificated,
})

export default connect(mapStateToProps)(SearchResultItem)
